<template>
 <div>
     <div id="sso" v-html="sso" ref="sso"></div>
     <!-- Modal -->
     <div v-if="showModal">
         <transition name="modal">
             <div class="modal-mask">
                 <div class="modal-wrapper">
                     <div class="modal-dialog modal-dialog-scrollable" role="document">
                         <div class="modal-content">
                             <div class="modal-header">
                                 <h5 class="modal-title">I need medical care</h5>
                                 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                     <span aria-hidden="true" @click="showModal = false">&times;</span>
                                 </button>
                             </div>
                             <div class="modal-body">
                                 <div v-if="step==0">
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <h3 class="mt-4">Hello {{name}}</h3>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="mt-3">First, let's find out what medical care you require by answering a few questions.</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <button class="btn btn-primary btn-sb btn-block" @click.prevent="step=1">
                                                LET'S GET STARTED
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                 <div v-if="step==1">
                                     <div class="row">
                                         <div class="col-md-12">
                                             <p class="small">
                                                 Select <span class="text-success">Yes</span> if your answer is Yes to any one of the questions below. Select <span class="text-danger">No</span> if your answer is No to all of the questions.
                                             </p>
                                             <hr/>
                                             <h5><strong>Is this a life or limb-threatening situation?</strong></h5>
                                             <hr/>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-6">
                                             <button class="btn btn-block btn-success" @click.prevent="step=2">
                                                 Yes
                                             </button>
                                         </div>
                                         <div class="col-md-6">
                                             <button class="btn btn-block btn-danger" @click.prevent="step=3">
                                                 No
                                             </button>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12 text-center mt-3">
                                             <a href="#" @click.prevent="step=0">Start Over</a>
                                         </div>
                                     </div>
                                 </div>
                                 <div v-if="step==2">
                                     <div class="row">
                                         <div class="col-md-12 text-center">
                                             <h3 class="mt-4">Hello {{name}}</h3>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12">
                                             <p class="mt-3">Based on your answers, You should call 911 immediately.</p>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12">
                                             <a href="tel:911" class="btn btn-danger btn-block">
                                                 CALL 911
                                             </a>
                                         </div>
                                     </div>
                                 </div>
                                 <div v-if="step==3">
                                     <div class="row">
                                         <div class="col-md-12">
                                             <p class="small">
                                                 Select <span class="text-success">Yes</span> if your answer is Yes to any one of the questions below. Select <span class="text-danger">No</span> if your answer is No to all of the questions.
                                             </p>
                                             <hr/>
                                             <h5><strong>Are you having difficulty breathing or shortness of breath?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you having pain or pressure in the chest or upper abdominal area?</strong></h5>
                                             <hr/>
                                             <h5><strong>Did you faint?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you experiencing sudden dizziness, weakness or change in vision?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you experiencing a sudden change in mental status - such as unusual behavior, confusion or difficulty waking up?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you experiencing severe pain anywhere in your body?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you experiencing bleeding that won't stop after several minutes of pressure?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you experiencing severe or persistent vomiting?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you coughing up blood or vomiting blood?</strong></h5>
                                             <hr/>
                                             <h5><strong>Do you think you broke a bone?</strong></h5>
                                             <hr/>
                                             <h5><strong>Do you feel suicidal or homicidal?</strong></h5>
                                             <hr/>
                                             <h5><strong>Are you alarmed by unusually severe symptoms that you think may indicate an emergency? Trust your instincts</strong></h5>
                                             <hr/>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-6">
                                             <button class="btn btn-block btn-success" @click.prevent="step=4">
                                                 Yes
                                             </button>
                                         </div>
                                         <div class="col-md-6">
                                             <button class="btn btn-block btn-danger" @click.prevent="step=5">
                                                 No
                                             </button>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12 text-center mt-3">
                                             <a href="#" @click.prevent="step=0">Start Over</a>
                                         </div>
                                     </div>
                                 </div>
                                 <div v-if="step==4">
                                     <div class="row">
                                         <div class="col-md-12 text-center">
                                             <h3 class="mt-4">Hello {{name}}</h3>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12">
                                             <p class="mt-3">You should go or be taken to closest Emergency Room.</p>
                                         </div>
                                     </div>
<!--                                     <div v-for="hpcontact in hpcontacts" class="row">-->
<!--                                         <div class="col-md-6">{{hpcontact.hpc_contactname}}</div>-->
<!--                                         <div class="col-md-6"><a :href="'tel:'+hpcontact.hpc_contactnumber">{{hpcontact.hpc_contactnumber}}</a> </div>-->
<!--                                     </div>-->
                                     <div class="row mt-3">
                                         <div class="col-md-12">
<!--                                             <a :href="link?link:'https://www.google.com/maps/search/Emergency+Room/'" target="_blank" class="btn btn-success btn-block">-->
<!--                                                 Find Closest Emergency Room-->
<!--                                             </a>-->
                                             <a v-if="checkProvider('UMR')" target="_blank"
                                                @click.prevent="ssoClick('umr', 'findaprovider')"
                                                class="btn btn-success btn-block"
                                                title="Redirect to umr.com">
                                                 Find a Provider
                                             </a>
                                             <a v-if="checkProvider('UHC')"
                                                target="_blank"
                                                href="https://retiree.uhc.com/compassrose/find-a-provider"
                                                class="btn btn-success btn-block"
                                                title="Redirect to uhc.com">
                                                 Find a Provider
                                             </a>
                                         </div>
                                     </div>
                                 </div>
                                 <div v-if="step==5">
                                     <div class="row">
                                         <div class="col-md-12">
                                             <p class="small">
                                                 Select <span class="text-success">Yes</span> if your answer is Yes to any one of the questions below. Select <span class="text-danger">No</span> if your answer is No to all of the questions.
                                             </p>
                                             <hr/>
                                             <h5><strong>Is your Primary Care Physician's office closed and you feel like you need treatment right away and cannot wait for his or her office to reopen?</strong></h5>
                                             <hr/>
                                             <h5><strong>Were you involved in an accident or did you fall within the last 24 hours and are you experiencing pain or discomfort that is affecting your ability to function?</strong></h5>
                                             <hr/>
                                             <h5><strong>Did you sprain or strain any part of your body within the last 48 hours and are you experiencing discomfort that interferes with your day to day activity?</strong></h5>
                                             <hr/>
                                             <h5><strong>Did you cut yourself and think you may need stitches?</strong></h5>
                                             <hr/>
                                             <h5><strong>Do you have back pain that is affecting your ability to function?</strong></h5>
                                             <hr/>
                                             <h5><strong>Do you have a fever?</strong></h5>
                                             <hr/>
                                             <h5><strong>Do you have a severe sore throat?</strong></h5>
                                             <hr/>
                                             <h5><strong>Do you think you have a urinary tract infection?</strong></h5>
                                             <hr/>
                                             <h5><strong>Do you feel poorly and cannot manage at home?</strong></h5>
                                             <hr/>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-6">
                                             <button class="btn btn-block btn-success" @click.prevent="step=6">
                                                 Yes
                                             </button>
                                         </div>
                                         <div class="col-md-6">
                                             <button class="btn btn-block btn-danger" @click.prevent="step=7">
                                                 No
                                             </button>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12 text-center mt-3">
                                             <a href="#" @click.prevent="step=0">Start Over</a>
                                         </div>
                                     </div>
                                 </div>
                                 <div v-if="step==6">
                                     <div class="row">
                                         <div class="col-md-12 text-center">
                                             <h3 class="mt-4">Hello {{name}}</h3>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12">
                                             <p class="mt-3">You should go to the closest Urgent Care Center. If there is not an Urgent Care Center within a reasonable distance from you, you should contact your Primary Care Physician (PCP) or consider going to the Emergency Room.</p>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12">
                                             <a v-if="checkProvider('UMR')" target="_blank"
                                                @click.prevent="ssoClick('umr', 'findaprovider')"
                                                class="btn btn-success btn-block"
                                                title="Redirect to umr.com">
                                                 Find a Provider
                                             </a>
                                             <a v-if="checkProvider('UHC')"
                                                target="_blank"
                                                href="https://retiree.uhc.com/compassrose/find-a-provider"
                                                class="btn btn-success btn-block"
                                                title="Redirect to uhc.com">
                                                 Find a Provider
                                             </a>
                                         </div>
                                     </div>
                                 </div>
                                 <div v-if="step==7">
                                     <div class="row">
                                         <div class="col-md-12 text-center">
                                             <h3 class="mt-4">Hello {{name}}</h3>
                                         </div>
                                     </div>
                                     <div class="row">
                                         <div class="col-md-12">
                                             <p class="mt-3">You should call your Primary Care Physician.</p>
                                             <hr/>
                                             <h5 class="text-center">No Primary Care Physician (PCP) noted.</h5>
                                         </div>
                                     </div>
                                 </div>

                             </div>
                             <div class="modal-footer">
                                 <button type="button" v-if="step>1" class="btn btn-primary" @click="back">Back</button>
                                 <button type="button" class="btn btn-secondary" @click="showModal = false">Close</button>

                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </transition>
     </div>
 </div>
</template>

<script>
    export default {
        props:['name','gravatar','hpcontacts','link', 'healthPlans'],
        mounted() {
        },
        data(){
            return {
                showModal: false,
                step:0,
                sso: '',
            }
        },
        created: function() {
            bus.$on('showHelp', this.show)
        },
        watch:{
            'showModal':function (val, oldVal) {
                if(val){
                    this.step=0;
                }
            }
        },
        methods:{
            show(){
                this.showModal=true
            },
            back(){
                switch(this.step) {
                    case 3:
                        this.step=1
                        break;
                    case 5:
                        this.step=3
                        break;
                    case 7:
                        this.step=5
                        break;
                    default:
                        this.step--;
                }
            },
            ssoClick(provider, path) {
                document.getElementById("overlay").style.display = "flex"; // Make sure the overlay is visible
                document.getElementById("overlay").style.zIndex = "9999";
                axios.get('/api/sso/' + provider + (path ? ('/' + path) : ''))
                    .then(res => {
                        this.sso = res.data.html;
                    }).then(() => {
                        this.$refs.sso.children[3].submit();
                        document.getElementById("overlay").style.display = "none";
                    });
            },
            checkProvider(provider) {
                if(this.healthPlans.healthplans==undefined)
                    return false;
                if(this.healthPlans.elig==undefined || this.healthPlans.elig.status==false)
                    return false;
                return !!this.healthPlans.healthplans.find(hp => hp.provider === provider);
            }
        }
    }
</script>
